import { APIError, StorageUploadError } from "@/adapters/api";

export const DOCUMENT_UPLOAD_MISSING = "document_upload_missing";
export const DOCUMENT_UPLOAD_INVALID = "document_upload_invalid";

const DOCUMENT_ERROR_MESSAGES: Record<string, string> = {
	[DOCUMENT_UPLOAD_MISSING]:
		"O arquivo não chegou ao armazenamento. Tente enviar de novo.",
	[DOCUMENT_UPLOAD_INVALID]:
		"O arquivo recebido não confere com o enviado e foi descartado.",
};

const VIOLATION_MESSAGES: Record<string, Record<string, string>> = {
	file_name: {
		unsupported_type: "Formato de arquivo não suportado.",
		required: "Nome do arquivo é obrigatório.",
	},
	size_bytes: {
		out_of_range: "O arquivo passa do limite de 50 MB ou está vazio.",
	},
	category: {
		invalid: "Categoria inválida.",
		required: "Categoria é obrigatória.",
	},
	title: {
		too_long: "O título pode ter no máximo 200 caracteres.",
		required: "Título é obrigatório.",
	},
};

function errorReason(err: APIError): string {
	return err.reason || err.code;
}

export function isDocumentUploadRestartRequired(err: unknown): boolean {
	if (!(err instanceof APIError)) return false;
	const reason = errorReason(err);
	return (
		reason === DOCUMENT_UPLOAD_MISSING ||
		reason === DOCUMENT_UPLOAD_INVALID ||
		err.code === "not-found"
	);
}

export function documentErrorMessage(err: unknown, fallback: string): string {
	if (err instanceof StorageUploadError) {
		return err.status === 0
			? "A conexão caiu durante o envio. Tente de novo."
			: "O armazenamento recusou o arquivo. Tente de novo.";
	}
	if (!(err instanceof APIError)) return fallback;
	const known = DOCUMENT_ERROR_MESSAGES[errorReason(err)];
	if (known) return known;
	const messages = Object.entries(err.violations).map(
		([field, description]) =>
			VIOLATION_MESSAGES[field]?.[description] ?? `${field}: ${description}`,
	);
	if (messages.length > 0) return messages.join(" ");
	return fallback;
}
